import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import ErrorPage from '@rsos/components/capstone/ErrorPage';
import { AppInnerWrapper } from '@rsos/components/capstone/Layout/AdminLayout/AdminLayout.styles';
import AppLoading from '@rsos/components/capstone/Layout/AppLoading';
import { KeywordManagementRouter } from './pages/KeywordManagementRouter';
import { persistor } from './state';
import type { KeywordDispatch } from './state';
import { initializationSelector, initialize } from './state/initialization';

// Init/permission gate for the keywords section. The consolidated admin shell
// (apps/admin/src/index.tsx) provides Provider/FlagProvider/PersistGate/
// BrowserRouter/Layout, so this section no longer wraps those itself.
const App = () => {
  const { initialized, initializing, error } = useSelector(
    initializationSelector,
  );

  const dispatch: KeywordDispatch = useDispatch();
  useEffect(() => {
    if (!(initialized || error)) {
      dispatch(initialize());
    }
  }, [dispatch, initialized, initializing, error]);

  if (error) {
    return <ErrorPage persistor={persistor} />;
  }

  if (initializing) {
    return <AppLoading />;
  }

  if (initialized) {
    return (
      <AppInnerWrapper>
        <KeywordManagementRouter />
      </AppInnerWrapper>
    );
  }

  return <ErrorPage persistor={persistor} />;
};

export default App;
